import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HipobuySpreadsheetGuide from "../pages/hipobuy-spreadsheet-guide/page";
import HipobuySpreadsheetReview from "../pages/hipobuy-spreadsheet-review/page";
import HipobuyVsKakobuySpreadsheet from "../pages/hipobuy-vs-kakobuy-spreadsheet/page";
import HipobuySpreadsheetSafety from "../pages/hipobuy-spreadsheet-safety/page";
import HipobuySpreadsheetBeginners from "../pages/hipobuy-spreadsheet-beginners/page";
import HipobuySpreadsheetTips from "../pages/hipobuy-spreadsheet-tips/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-spreadsheet-guide",
    element: <HipobuySpreadsheetGuide />,
  },
  {
    path: "/hipobuy-spreadsheet-review",
    element: <HipobuySpreadsheetReview />,
  },
  {
    path: "/hipobuy-vs-kakobuy-spreadsheet",
    element: <HipobuyVsKakobuySpreadsheet />,
  },
  {
    path: "/hipobuy-spreadsheet-safety",
    element: <HipobuySpreadsheetSafety />,
  },
  {
    path: "/hipobuy-spreadsheet-beginners",
    element: <HipobuySpreadsheetBeginners />,
  },
  {
    path: "/hipobuy-spreadsheet-tips",
    element: <HipobuySpreadsheetTips />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;